import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Shield, ArrowLeft } from 'lucide-react';
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from '@/components/ui/input-otp';

export const TwoFactorPage = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // TODO: Implement 2FA verification
      console.log('Verifying code:', code);
    } catch (err) {
      setError('Invalid verification code. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-md space-y-8 rounded-lg border border-white/10 bg-card2 p-8">
        <div className="flex flex-col items-center justify-center text-center">
          <div className="mb-4 rounded-full border border-white/10 p-3">
            <Shield className="h-6 w-6 text-lime" />
          </div>
          <h2 className="text-2xl font-bold text-white">Two-Factor Authentication</h2>
          <p className="mt-2 text-sm text-gray-400">
            Enter the verification code sent to your device
          </p>
        </div>

        <form onSubmit={handleSubmit} className="mt-8 flex w-full flex-col items-center space-y-6">
          <div className="flex justify-center">
            <InputOTP maxLength={6} className="">
              <InputOTPGroup>
                <InputOTPSlot index={0} />
                <InputOTPSlot index={1} />
                <InputOTPSlot index={2} />
              </InputOTPGroup>
              <InputOTPSeparator />
              <InputOTPGroup>
                <InputOTPSlot index={3} />
                <InputOTPSlot index={4} />
                <InputOTPSlot index={5} />
              </InputOTPGroup>
            </InputOTP>
          </div>

          {error && <p className="text-sm text-red-500">{error}</p>}

          <div className="w-full space-y-4">
            <Button type="submit" className="w-full" disabled={isLoading || code.length !== 6}>
              {isLoading ? 'Verifying...' : 'Verify'}
            </Button>

            <Button
              type="button"
              variant="outline"
              className="w-full"
              onClick={() => window.history.back()}
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Login
            </Button>
          </div>
        </form>

        <div className="mt-4 text-center">
          <Button variant="link" className="text-sm text-gray-400 hover:text-lime">
            Didn't receive a code? Resend
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TwoFactorPage;
